module.exports = __webpack_public_path__ + "img/coin_pennies.d2a5897e.svg";